<template>
  <div class="getway-record page-padding flex-auto">
    <ioc-table
      ref="crud"
      :data="tableData"
      :option="option"
      :page="page"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      @search-reset="searchData"
      @search-change="searchData"
    ></ioc-table>
  </div>
</template>

<script>
import { getwayControl } from "../api";
import utils from "@src/common/utils";
import { Dic } from "$utils";
const CMD_TYPES = {
  1: "打开道闸",
  2: "关闭道闸",
  3: "常开",
  4: "常关",
};
export default {
  components: {},
  props: {},
  data() {
    return {
      recordModel: {},
      tableData: [],
      page: {
        currentPage: 1,
        total: 0,
        pageSize: utils.Cache.get("CURRENT_PAGESIZE") || 10,
      },
      option: {
        page: true,
        index: true,
        indexLabel: "序号",
        stripe: true,
        maxHeight: "100%",
        emptyText: "暂无数据",
        column: [
          // {
          //   label: "通道编号",
          //   prop: "deviceName",
          //   align: "center",
          // },
          {
            label: "通道名称",
            prop: "deviceName",
            align: "center",
            search: true,
          },
          {
            label: "控制类型",
            prop: "cmdType",
            align: "center",
            formatter: function (row, value) {
              return value ? CMD_TYPES[value] : "";
            },
          },

          {
            label: "操作员",
            prop: "operatorName",
            align: "center",
            search: true,
          },
          {
            label: "操作时间",
            prop: "operateTime",
            align: "center",
            type: "datetimerange",
            search: true,
          },
          // {
          //   label: "开闸原因",
          //   prop: "cmdType",
          //   align: "center",
          // },
        ],
      },
    };
  },
  created() {
    this.loadData();
  },
  methods: {
    searchData(searchForm = {}) {
      this.searchForm = {
        operatorName: searchForm.operatorName,
        beginTime:
          searchForm.operateTime &&
          searchForm.operateTime.length >= 1 &&
          this.$utils.getDateStr(searchForm.operateTime[0]),
        endTime:
          searchForm.operateTime &&
          searchForm.operateTime.length >= 2 &&
          this.$utils.getDateStr(searchForm.operateTime[1]),
        deviceName: searchForm.deviceName
      };
      this.page.currentPage = 1;
      this.loadData();
    },
    loadData() {
      const loading = this.$loading({
        lock: true,
        text: "请求中",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      this.$fetch(getwayControl.queryVehicleBarrierControlRecordList, {
        pageNum: this.page.currentPage,
        pageSize: this.page.pageSize,
        ...this.searchForm,
      }).then((res) => {
        setTimeout(() => {
          loading.close();
        }, 500);

        if (res.success) {
          this.page.total = res.returnObj.total;
          this.tableData = res.returnObj.list || [];
        }
      });
    },
    handleCurrentChange(val) {
      this.page.currentPage = val;
      this.loadData();
    },
    handleSizeChange(val) {
      this.page.currentPage = 1;
      this.page.pageSize = val;
      this.loadData();
    },
  },
  mounted() {},
};
</script>
<style lang="scss" scoped></style>
